export class ShowFertilizerUseCase {
  constructor(api){
    this.api=api
  }
  async execute() {
    const raw = `
      SELECT * FROM CROP.FERTILIZER;
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }
}
